export enum RenewalPath {
  SECTION = ':sectionId',
  ADDITIONAL_PROFILE = ':profileId?',
}
